
//import ApiService from "@/core/services/ApiService";
import { defineComponent } from "vue";
import { Field } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import ApiService from "@/core/services/ApiService";
import { VueCookieNext } from 'vue-cookie-next';

export default defineComponent({
  name: "trainee_infoEdit",
  components: {
    Field,
  },
  data() {
    return {
      formData: {
        id: "",
        present_district: "",
        per_district: "",
        per_upazilla: "",
        home_district: "",
        family_monthly_income: "",
        father_annual_income: "",
      },

      load: false,
      districts: [],
      subDistricts: [],
    };
  },
  async created() {
    this.load = true;
    this.emitter.on("trainee_info_updated", async (data) => {
      this.formData = data;
      setTimeout(() => (this.load = false), 2000);
    });
    await this.getDistricts();
    await this.getSubDistricts();
  },
  methods: {
    async getDistricts() {
      await ApiService.get("configurations/geo_district/list")
        .then((response) => {
          this.districts = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getSubDistricts() {
      await ApiService.get(
        "configurations/geo_upazila/list?district=" +
          this.formData.present_district
      )
        .then((response) => {
          this.subDistricts = response.data.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async formSubmit() {
      let formData = new FormData();
      for (var key in this.formData) {
        formData.set(key, this.formData[key]);
      }
      let user_id = VueCookieNext.getCookie('_seip_user');
      formData.set('user_id', user_id.id);
      await ApiService.post("trainee/updateTraineeInfo", formData)
        .then((response) => {
          DrawerComponent?.hideAll();
          if (response.status == 200) {
            if (response.data.status == "error") {
              Swal.fire({
                title: "Error!",
                html: response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Close",
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            } else {
              Swal.fire({
                title: "Success!",
                text: response.data.data,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then(() => {
                //this.$router.push("/sign-up");
              });
            }
          } else {
            let err = "";
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + "<br>";
            }
            Swal.fire({
              title: "Please check all the required field",
              html: err,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Close",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        })
        .catch(({ response }) => {
          Swal.fire({
            title: "Unknown error",
            html: response.data.error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Close",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        });
    },
  },
});
